<script lang="ts">
  import { splitProductAndTextLogs } from "../../lib/conversation";
  import { slide } from "svelte/transition";
  import styles from "./styles";
  import ProductResponse from "./Chat/ProductResponse.svelte";

  export let text: string;
  // Using export const for props used for external reference only
  export const language: string = "";
  export let createdAt: Date = new Date();
  export let chatHidden: boolean = false;
  export let color: string | undefined = undefined;
  export let position = "right";
  export let fontColor: string | undefined = undefined;

  let withinVisibleTime = true;
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let splitLogs: Array<{ text?: string; productUrl?: string }> = [];

  const s = styles({ headerColor: color, fontColor });

  function computeVisibility() {
    // If it is being recalculated before 3s, cancel the prevous timeout.
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    const lastPreviewShown = localStorage.getItem("lastPreviewShown");
    if (lastPreviewShown && new Date(lastPreviewShown) > createdAt) {
      // Do not show the preview if the same message has been already shown.
      withinVisibleTime = false;
      return;
    } else {
      localStorage.setItem("lastPreviewShown", new Date().toISOString());
    }

    withinVisibleTime = true;
    timeout = setTimeout(() => {
      withinVisibleTime = false;
    }, 10000);
  }

  function trim(text: string): string {
    if (!text) return text;

    if (text.length > 256) {
      return text.slice(0, 256) + "...";
    }

    return text;
  }

  $: text && createdAt && computeVisibility();
  $: splitLogs = splitProductAndTextLogs(text);
</script>

{#if chatHidden && text && text !== "" && withinVisibleTime}
  <div
    class={s.previewBubbleContainer}
    style={`${position}: ${position === "right" ? "0" : "-4px"};`}
    in:slide
    out:slide
  >
    {#each splitLogs as log}
      {#if log.productUrl}
        <a class={s.previewBubbleProduct} href={log.productUrl}>
          <ProductResponse
            {s}
            {log}
            overrideStyleRow="justify-content: flex-start;"
          />
        </a>
      {:else}
        <div class={s.chatBubblePreview}>
          {trim(log.text || "")}
        </div>
      {/if}
    {/each}
  </div>
{/if}
